/* globals $:false */

import utils from '@cob/ui-genesis/cob.utils.js';

// Component capable of handling only text fields
//
// args:
// * `confs`: the field configuration
//
// confs:
// * `id`: the input attr id
// * `cssClasses`: A space separated list of css classes to add to the input
// * `readonly`: true or false. Defaults to false
// * `valueChanged(newValue)`: Invoked when a user changes the value,
//
var Text = function(core, confs) {

    var _$input,
        _lastValue;

    var _confs = {
        id: core.locallyUniqueId(),
        cssClasses: undefined,
        readonly: false,
        valueChanged: undefined
    };

    utils.extend(_confs, confs, true);

    var _setValue = function(value) {
        // We just want to notify
        // when the value changes.
        if (_lastValue !== value) {
            _lastValue = value;

            if (_confs.valueChanged) {
                _confs.valueChanged(value);
            }
        }
    };

    var _onValueChange = function() {
        _setValue(_$input.val());
    };

    var _render = function() {
        var $html = $([
            '<div class="inline">',
            '<input id="f' + _confs.id + '" class="field-value cob-field-value" type="text">',
            '</div>'
        ].join(''));

        _$input = $html.find("input");

        if (_confs.cssClasses) {
            _$input.addClass(_confs.cssClasses);
        }

        if (_confs.readonly) {
            _$input.attr("readonly", "readonly").attr("tabindex", -1);
        } else {
            _$input.on('keydown paste blur change', _onValueChange);
        }

        if (_lastValue) {
            _$input.val(_lastValue);
        }

        return $html;
    };

    var _clearError = function() {
        _$input.removeClass("error");
    };

    var _showError = function() {
        _$input.addClass("error");
    };

    var _destroy = function() {
        if (!_confs.readonly) {
            _$input.off('keydown paste blur change', _onValueChange);
        }
    };

    return {
        render: _render,
        destroy: _destroy,

        clearError: _clearError,
        showError: _showError,

        setValue: function(value) {
            if (_$input) {
                _$input.val(value);
            }

            // Notify that this field has a new value because
            // I want to update the $auto.join and other fields...
            _setValue(value);
        },
        getValue: function() {
            return _lastValue;
        },

        isEnabled: function () {
            return !_$input.prop('readonly');
        }
    }
};

export default Text;
